import Router from 'next/router'
import { Machine, assign } from 'xstate'
import { notification } from 'antd'
import auth, { loginUser } from '_helpers/authHelper'

const loginMachine = Machine({
  id: 'loginMachine',
  initial: 'ready',
  context: {
    formData: {},
    errorMessage: null,
    redirectUrl: '/',
  },
  states: {
    ready: {
      on: {
        LOGIN: {
          target: 'loading',
          actions: assign({
            formData: (_context, payload) => payload,
            redirectUrl: (_context, { redirectUrl }) => redirectUrl,
          }),
        },
      },
    },
    loading: {
      invoke: {
        src: ({ formData: { email, password }, updateCurrentUser }) =>
          loginUser({ email, password, updateCurrentUser }),
        onDone: {
          target: 'ready',
          actions: assign({
            errorMessage: ({ redirectUrl }, { data }) => {
              if (data.error) {
                return 'Invalid Email/Password'
              } else {
                auth.setAccessToken(data.accessToken)
                Router.push(redirectUrl || '/')
                return ''
              }
            },
          }),
        },
        onError: {
          target: 'ready',
          actions: () => {
            notification.error({
              message: 'Something is Wrong!',
              description: 'Please try again later.',
            })
          },
        },
      },
    },
  },
})

export default loginMachine
